<template>
  <div
    v-if="list.printTagTutorial"
    class="tutorial"
  >
    <img
      src="/static/images/close-tutorial.svg"
      class="tutorial__close"
      alt="botao-fechar"
      @click="readTutorialAndRefreshPage"
    >
    <div
      v-for="(step, index) in steps"
      :key="index + 0"
    >
      <transition
        name="fade"
        mode="out-in"
      >
        <component
          :is="step.layout"
          v-if="step.visible"
          :content="step"
          :next-step="nextStep"
          :previous-step="previousStep"
          :repeat-tutorial="repeatTutorial"
        />
      </transition>
    </div>
    <div class="background" />
  </div>
</template>

<script>
import InitialTemplate from './templates/Initial'
import TopTemplate from './templates/Top'
import LeftTemplate from './templates/Left'
import BottomTemplate from './templates/Bottom'
import FinalTemplate from './templates/Final'
import RightTemplate from './templates/Right'
import CenteredTemplate from './templates/Centered'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Tutorial',
  components: {
    'initial-template': InitialTemplate,
    'top-template': TopTemplate,
    'left-template': LeftTemplate,
    'bottom-template': BottomTemplate,
    'final-template': FinalTemplate,
    'right-template': RightTemplate,
    'centered-template': CenteredTemplate
  },
  props: ['steps'],
  data: () => ({
    index: 0
  }),
  computed: {
    ...mapGetters({ list: 'tutorialsList' }),
    step: function () {
      return this.steps[this.index]
    }
  },
  methods: {
    ...mapActions(['mockFakeBatchesForTutorial']),
    ...mapActions(['updateTutorialsList']),
    readTutorialAndRefreshPage() {
      this.updateTutorialsList({ tutorial: 'printTagTutorial', action: false })
      this.unsetHighlight(this.step.elementIdToHilight)
      this.unsetPeseudoStyle(this.step.elementIdToHilight)
      window.scrollTo(0, 0)

      window.location.reload()
    },
    setHighlight(id) {
      if (id) {
        document.getElementById(id).style.zIndex = 401
        document.getElementById(id).classList.add('avoid-clicks')
      }
    },
    setAdditionalStyles(id, styles) {
      for (var i = 0; i < styles.length; i++) {
        document.getElementById(id).style[styles[i].style] = [styles[i].value]
      }
    },
    setBeforeStyles(id, styles) {
      var styleElem = document.head.appendChild(document.createElement('style'))
      styleElem.innerHTML = '#' + id + ':before {' + styles + '}'
    },
    setAfterStyles(id, styles) {
      var styleElem = document.head.appendChild(document.createElement('style'))
      styleElem.innerHTML = '#' + id + ':after {' + styles + '}'
    },
    unsetHighlight(id) {
      if (id) {
        document.getElementById(id).removeAttribute('style')
      }
    },
    unsetPeseudoStyle(id) {
      if (id) {
        var styleBefore = document.head.appendChild(document.createElement('style'))
        styleBefore.innerHTML = '#' + id + ':before {display: none}'
        var styleAfter = document.head.appendChild(document.createElement('style'))
        styleAfter.innerHTML = '#' + id + ':after {display: none}'
      }
    },
    runSteps() {
      this.step.visible = true
      let id = this.step.elementIdToHilight
      let beforeStyles = this.step.beforeStyles
      let afterStyles = this.step.afterStyles

      if (id) {
        this.setHighlight(id)
        if (this.step.additionalStyles) {
          this.setAdditionalStyles(id, this.step.additionalStyles)
        }
        if (this.step.beforeStyles) {
          this.setBeforeStyles(id, beforeStyles)
        }
        if (this.step.afterStyles) {
          this.setAfterStyles(id, afterStyles)
        }
      }
    },
    nextStep() {
      this.unsetHighlight(this.step.elementIdToHilight)
      this.unsetPeseudoStyle(this.step.elementIdToHilight)
      this.step.visible = false
      this.index++
      this.runSteps()
    },
    previousStep() {
      this.unsetHighlight(this.step.elementIdToHilight)
      this.unsetPeseudoStyle(this.step.elementIdToHilight)
      this.step.visible = false
      if (this.index > 0) this.index--
      this.runSteps()
    },
    repeatTutorial() {
      this.unsetHighlight(this.step.elementIdToHilight)
      this.step.visible = false
      this.index = 0
      this.runSteps()
    },
    startTutorial() {
      document.getElementById('mainScroll').style.overflowY = 'hidden'
      this.runSteps()
      this.mockFakeBatchesForTutorial()
    }
  },
  watch: {
    list: {
      handler: function (newList) {
        console.log('newList', newList)
        if (newList.printTagTutorial) this.startTutorial()
      },
      deep: true
    }
  },
  beforeDestroy() {
    document.getElementById('mainScroll').style.overflowY = 'auto'
    this.steps[this.index].visible = false
    this.unsetHighlight(this.steps[this.index].elementIdToHilight)
  }
}
</script>

<style lang="scss">
.tutorial {
  &__close {
    z-index: 9999999;
    position: fixed;
    right: 40px;
    top: 40px;
    cursor: pointer;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }

  .background {
    opacity: 1;
    pointer-events: auto;
    position: fixed;
    z-index: 400;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.9);
    transform: translateZ(0);
    transition: all 0.5s cubic-bezier(0.35, 0, 0.25, 1);
  }

  .skip-presentation {
    z-index: 9004;
    position: fixed;
    bottom: 10%;
    right: 15%;
    cursor: pointer;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    line-height: 26px;
    font-size: 18px;
    color: #e5e5e5;
    text-decoration-line: underline;
  }

  h1 {
    color: #e59449;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    line-height: 34px;
    font-size: 34px;

    img {
      padding-left: 0.5em;
    }
  }

  .description-container {
    padding-top: 1em;

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      line-height: 26px;
      font-size: 18px;
      color: #e5e5e5;

      span {
        color: #e59449;
      }
    }
  }
}

.fade-enter-active {
  transition: all 0.8s ease;
}
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
</style>
